import React from "react";
import "./Projects.scss";

const Projects = ({ componentOffsetTop }) => {
  return (
    <div
      id="projects"
      className="projects"
      ref={(e) => (componentOffsetTop.current[6] = e)}
    >
      <h1>PROJECTS</h1>
      <div className="project-container">
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>My Porfile</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/my-profile"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
            </div>
          </div>
          <img src="projects/portfolio.jpg" alt="profile" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Application Process</p>
            </div>
            <div>
              <a
                href="https://application-process.staging.codeyourfuture.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/CYF-application.jpg" alt="CYF-application" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>QueueAndA</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/QueueAndA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-queueanda.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/QueueAndA.jpg" alt="QueueAndA" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Chat App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/node-challenge-chat-server"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://app.netlify.com/sites/elegant-bhaskara-173ed9/overview"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/chat.jpg" alt="chat" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Countries App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/countries-project"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-erwin6997-countries.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/countries.jpg" alt="countries" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Responsive grid</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/responsive-grid-project"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-responsin-meisam.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/responsive.jpg" alt="responsive" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>TV Show App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/tv-show-dom-project"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-erwin6997-tv.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/tvshow.jpg" alt="tvshow" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Hotel App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/cyf-hotel-react"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-erwin6997-hotel-react.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/hotel.jpg" alt="hotel" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>TFL Line App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/tfl-lines-react"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-erwin6997-tfl-lines.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/tflline.jpg" alt="tflline" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Quote App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/node-challenge-quote-server"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-meisam-quotegenerator.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/qoute.jpg" alt="qoute" />
        </div>

        
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Baby Names App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/baby-names-react"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-erwin6997-baby-names.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/babyname.jpg" alt="babyname" />
        </div>
        <div className="project-card">
          <div className="hover-link animate__animated animate__fadeIn">
            <div>
              <p>Karma Clone App</p>
            </div>
            <div>
              <a
                href="https://github.com/Erwin6997/karma-clone"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-code"></i>
              </a>
              <a
                href="https://cyf-meisam-kalam.netlify.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-globe"></i>
              </a>
            </div>
          </div>
          <img src="projects/karma.jpg" alt="karma" />
        </div>
      </div>
    </div>
  );
};

export default Projects;
